import { atom } from 'jotai';

const brokenImageUrlsAtom = atom([]);

export default brokenImageUrlsAtom;
